import ClinicAddress from "./ClinicAddress";

export default class Invoice {
  constructor(
    public readonly date: string,
    public readonly receipt_no: string,
    public readonly appointment_id: number | null,
    public readonly lab_report_id: number | null,
    public readonly payment_mode: string | null,
    public readonly bank_name: string | null,
    public readonly bank_branch: string | null,
    public readonly transaction_id: string | null,
    public readonly cheque_no: string | null,
    public readonly card_cheque_type: string | null,
    public readonly account_holder: string | null,
    public readonly invoice_type: string,
    public readonly patient_id: string,
    public readonly patient_name: string,
    public readonly patient_mobile: string,
    public readonly patient_email: string,
    public readonly doctor_name: string,
    public readonly doctor_reg_no: string | null,
    public readonly doctor_speciality: string | null,
    public readonly clinic_name: string,
    public readonly clinic_address: ClinicAddress,
    public readonly clinic_phone: string,
    public readonly clinic_email: string,
    public readonly consult_description: string,
    public readonly consult_inv_amount: number,
    public readonly consult_inv_sgst_amount: number,
    public readonly consult_inv_cgst_amount: number,
    public readonly particulars: string | null,
    public readonly discount: number,
    public readonly total_amount: number,
    public readonly total_sgst_amount: number,
    public readonly total_cgst_amount: number,
    public readonly paid_amount: number,
    public readonly pending_amount: number,
    public readonly payment_status: string,
  ) {}
}
